import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { apiRequest } from '@/utils/request'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('tc_t') || '')
  const username = ref(localStorage.getItem('username') || '')
  const allowUpdate = ref(localStorage.getItem('allowUpdate') === 'true')
  const userMenus = ref([])

  const isAuthenticated = computed(() => !!token.value)

  // 登录
  const login = async (credentials) => {
    try {
      // 使用后端旧版登录接口 /api/token/generate（JSON格式）
      const response = await fetch('/api/token/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
        credentials: 'include'
      })
      
      const result = await response.json()
      
      if (result.code === 200) {
        token.value = result.data?.token || result.token || credentials.username + '_token'
        username.value = result.data?.username || credentials.username
        allowUpdate.value = result.data?.allowUpdate || true
        
        localStorage.setItem('tc_t', token.value)
        localStorage.setItem('username', username.value)
        localStorage.setItem('allowUpdate', allowUpdate.value)
        
        await loadUserMenus()
        return { success: true }
      } else {
        return { success: false, message: result.message || '登录失败' }
      }
    } catch (error) {
      console.error('登录错误:', error)
      return { success: false, message: '登录失败，请检查网络连接' }
    }
  }

  // 登出
  const logout = async () => {
    try {
      await apiRequest.get('/api/logout')
    } catch (error) {
      console.error('登出请求失败:', error)
    } finally {
      token.value = ''
      username.value = ''
      allowUpdate.value = false
      userMenus.value = []
      
      localStorage.removeItem('tc_t')
      localStorage.removeItem('username')
      localStorage.removeItem('allowUpdate')
    }
  }

  // 加载用户菜单
  const loadUserMenus = async () => {
    try {
      const response = await apiRequest.get('/api/sys/function/current')
      if (response.code === 200) {
        userMenus.value = response.data
        return response.data
      }
    } catch (error) {
      console.error('加载用户菜单失败:', error)
    }
    return []
  }

  // 初始化认证状态
  const initAuth = () => {
    if (token.value) {
      loadUserMenus()
    }
  }

  // 修改密码
  const changePassword = async (passwordData) => {
    try {
      const response = await apiRequest.post('/api/sys/user/updatePassword', passwordData)
      return { success: response.code === 200, message: response.message }
    } catch (error) {
      return { success: false, message: '修改密码失败' }
    }
  }

  return {
    token,
    username,
    allowUpdate,
    userMenus,
    isAuthenticated,
    login,
    logout,
    loadUserMenus,
    initAuth,
    changePassword
  }
})
